import { render, staticRenderFns } from "./card-audio.vue?vue&type=template&id=f071a66c&scoped=true"
import script from "./card-audio.vue?vue&type=script&lang=js"
export * from "./card-audio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f071a66c",
  null
  
)

export default component.exports